

















































import { Component, Vue, Watch } from "vue-property-decorator";
import InitAssessment from "@/components/assessment/initAssessment.vue";
import AssessmentGrid from "@/components/assessment/assessmentGrid.vue";
import AssessmentList from "@/components/assessment/assessmentList.vue";
import AssessmentReview from "@/components/assessment/assessmentReview.vue";
import PreAssessmentRecord from "@/components/assessment/preAssessmentRecord.vue";
import AssessmentRecord from "@/components/assessment/assessmentRecord.vue";
import { postAssessmentApi } from "@/api.ts";
import { Getter, Action } from "vuex-class";
import { InitAssessmentPost } from "../../types";

@Component({
  components: {
    InitAssessment,
    AssessmentGrid,
    AssessmentList,
    AssessmentReview,
    PreAssessmentRecord,
    AssessmentRecord,
  },
})
export default class AssessmentBase extends Vue {
  @Getter private JWT?: string;
  @Getter private UID?: string;
  @Action private setInitAssessment!: any;

  private stage = 0;
  private goalSelectedPosition = -1;
  private audienceSelectedPosition = -1;
  private presentationSelectedPosition = -1;
  private practiceSelectedPosition = -1;
  private goalItemSelected: any;
  private audienceItemSelected: any;
  private presentationItemSelected: any;
  private practiceItemSelected: any;
  private initAssessmentPost?: InitAssessmentPost;

  private goalList = {
    type: "Main Goal",
    title: "What skill do you want to improve the most?",
    list: [
      {
        value: "overcomingNerves",
        text: "Overcoming Nerves",
        image: require("../../assets/images/assessments/nerves.svg"),
        description:
          "Getting more comfortable speaking in front of other people",
      },
      {
        value: "speakingPace",
        text: "Speaking Pace",
        image: require("../../assets/images/assessments/speakingPace.svg"),
        description:
          "Speaking at a rate that is easy to understand and engaging",
      },
      {
        value: "removingFillers",
        text: "Removing Fillers",
        image: require("../../assets/images/assessments/removingFillers.svg"),
        description: "Stop saying um, uh, like, and other filler words",
      },
      {
        value: "facialExpression",
        text: "Facial Expression",
        image: require("../../assets/images/assessments/facialExpression.svg"),
        description: "Using your facial expressions to engage your audience.",
      },
      {
        value: "vocalClarity",
        text: "Vocal Clarity",
        image: require("../../assets/images/assessments/vocalClarity.svg"),
        description:
          "Improving your enunciation of words so your audience can understand you",
      },
      {
        value: "conciseLanguage",
        text: "Using Concise Language",
        image: require("../../assets/images/assessments/conciseLanguage.svg"),
        description: "Removing unnecessary words from your speech",
      },
      {
        value: "speakingEnergy",
        text: "Speaking with Energy",
        image: require("../../assets/images/assessments/speakingEnergy.svg"),
        description: "Using vocal energy to keep your audience engaged",
      },
      {
        value: "intentionalPausing",
        text: "Intentional Pausing",
        image: require("../../assets/images/assessments/intentionalPause.svg"),
        description:
          "Pausing to add emphasis in specific places in your speech",
      },
    ],
  };

  private audienceList = {
    type: "Main Audience",
    title: "Who is your main audience when giving presentations?",
    list: [
      {
        value: "teamWork",
        text: "My Team at Work",
        image: require("../../assets/images/assessments/myTeam.svg"),
        description: "People you work with on an at least fairly regular basis",
      },
      {
        value: "superiorWork",
        text: "Superior(s) at Work",
        image: require("../../assets/images/assessments/superiorWork.svg"),
        description: "People in your company at a higher level than you",
      },
      {
        value: "group50+",
        text: "Groups of 50+ People",
        image: require("../../assets/images/assessments/groupPeople.svg"),
        description: "Large groups of people who you may or may not know",
      },
      {
        value: "peopleCommunity",
        text: "People in My Community",
        image: require("../../assets/images/assessments/peopleCommunity.svg"),
        description:
          "Groups of people in your community that you probably know",
      },
      {
        value: "customersClients",
        text: "Customers or Clients",
        image: require("../../assets/images/assessments/customersIcon.svg"),
        description: "Customers or clients that you communicate with for work",
      },
      {
        value: "otherAudience",
        text: "Other Audience",
        image: require("../../assets/images/assessments/otherIcon.svg"),
        description:
          "Choose this if you mainly present to a different audience than those listed",
      },
    ],
  };

  private presentationList = {
    type: "Presentation Confidence",
    title: "How confident do you feel when giving presentations?",
    list: [
      {
        text: "Not at all confident",
        image: require("../../assets/images/assessments/notAllConfident.svg"),
        description: "No worries! Orai is here to help you build confidence.",
      },
      {
        text: "Not very confident",
        image: require("../../assets/images/assessments/notVeryConfident.svg"),
        description: "We'll be building that confidence up in no time!",
      },
      {
        text: "Neutral",
        image: require("../../assets/images/assessments/neutral.svg"),
        description: "You're halfway there! Orai will help you with the rest.",
      },
      {
        text: "Pretty confident",
        image: require("../../assets/images/assessments/prettyConfident.svg"),
        description:
          "Practice makes perfect! Orai can help you get even more confident.",
      },
      {
        text: "Totally confident",
        image: require("../../assets/images/assessments/totallyConfident.svg"),
        description:
          "Confidence is key! Glad to see that you've already got it!",
      },
    ],
  };

  private practiceList = {
    type: "Confidence Without Preparation",
    title:
      "How confident do you feel when speaking without preparation or practice?",
    list: [
      {
        text: "Not at all confident",
        image: require("../../assets/images/assessments/notAllConfident.svg"),
        description:
          "You're not alone! Speaking on the spot is tough for most people.",
      },
      {
        text: "Not very confident",
        image: require("../../assets/images/assessments/notVeryConfident.svg"),
        description:
          "Practicing with Orai will help you feel confident, even without preparation!",
      },
      {
        text: "Neutral",
        image: require("../../assets/images/assessments/neutral.svg"),
        description:
          "As you practice good speaking, even presenting on the spot will get easier!",
      },
      {
        text: "Pretty confident",
        image: require("../../assets/images/assessments/prettyConfident.svg"),
        description:
          "You're nearly there! Orai can help you over the finish line.",
      },
      {
        text: "Totally confident",
        image: require("../../assets/images/assessments/totallyConfident.svg"),
        description:
          "Being confident while speaking on the spot is impressive - great work!",
      },
    ],
  };

  private gotoNext() {
    this.stage += 1;
    if (this.stage === 5) {
      this.goalItemSelected = {
        type: this.goalList.type,
        item: this.goalList.list[this.goalSelectedPosition],
      };
      this.audienceItemSelected = {
        type: this.audienceList.type,
        item: this.audienceList.list[this.audienceSelectedPosition],
      };
      this.presentationItemSelected = {
        type: this.presentationList.type,
        item: this.presentationList.list[this.presentationSelectedPosition],
      };
      this.practiceItemSelected = {
        type: this.practiceList.type,
        item: this.practiceList.list[this.practiceSelectedPosition],
      };
    } else if (this.stage === 6) {
      this.initAssessmentPost = {
        skillToImprove: this.goalList.list[this.goalSelectedPosition].value,
        mainAudience: this.audienceList.list[this.audienceSelectedPosition]
          .value,
        givingPresentations: this.presentationSelectedPosition + 1,
        speakNoPractice: this.practiceSelectedPosition + 1,
      };
    } else if (this.stage === 8) {
      this.$emit("done");
    }
  }

  private gotoEdit() {
    this.stage = 1;
  }

  private onSelectedOption(selectedOption: number) {
    if (this.stage === 1) {
      this.goalSelectedPosition = selectedOption;
    } else if (this.stage === 2) {
      this.audienceSelectedPosition = selectedOption;
    } else if (this.stage === 3) {
      this.presentationSelectedPosition = selectedOption;
    } else if (this.stage === 4) {
      this.practiceSelectedPosition = selectedOption;
    }
  }

  private postAssessmentApi() {
    this.setInitAssessment(true);
    if (this.JWT && this.UID && this.initAssessmentPost) {
      postAssessmentApi(
        this.JWT,
        this.UID,
        this.initAssessmentPost,
        (success: string) => {},
        (error: string) => {}
      );
    }
  }
}
